module.exports = __webpack_public_path__ + "img/whatsapp.01c61745.svg";